document.addEventListener('DOMContentLoaded', () => {
  const videoItems = document.querySelectorAll('.video-item');
  const videoPlayer = document.getElementById('video-player');
  const closeVideoButton = document.getElementById('close-video-button');
  const videoItemContent = document.querySelectorAll('.video-item-content');
  const muteVideoButton = document.getElementById('mute-video-button');
  const playPauseButtons = document.querySelectorAll('.play-pause-button');
  const progressBar = document.getElementById('byteex-video-player-progress-bar');
  const shareVideoPopupOpenButton = document.getElementById('share-video-button');
  const shareVideoPopup = document.getElementById('byteex-video-share-popup');
  const shareVideoLinkButton = document.getElementById('byteex-video-share-link-button');
  const shareVideoPopupCloseButton = document.getElementById('byteex-video-share-popup-close-button'); 
  const shareVideoLinks = document.querySelectorAll('.byteex-video-share-link');
  const videoThumbnailItems = document.querySelectorAll('.byteex-video-thumbnail-item');

  const url_params = new URLSearchParams(window.location.search);
  const param_video = url_params.get('video');

  let video = null;
  let videoIndex = 0;
  let muted = false;

  function updateProgressBar() {
    const val = (progressBar.value - progressBar.min) / (progressBar.max - progressBar.min) * 100;
    progressBar.style.background = `linear-gradient(to right, #ffffff 0%, #ffffff ${val}%, #6e6e6e ${val}%, #6e6e6e 100%)`;
  }

  function progressBarVideoUpdate() {
    progressBar.value = video.currentTime;
    progressBar.max = video.duration;
    updateProgressBar();
  }

  function progressBarInputUpdate() {
    video.currentTime = progressBar.value;
    updateProgressBar();
  }

  function muteVideoUpdate() {
    muted = !muted;
    video.muted = muted;

    if (video.muted) {
      muteVideoButton.querySelector('#muted-button').classList.remove('hidden');
    } else {
      muteVideoButton.querySelector('#muted-button').classList.add('hidden');
    }
  }

  function handleVideoThumbnailClick(event) {
    const currentThumbnailItem = event.currentTarget;

    videoThumbnailItems.forEach(videoThumbnailItem => {
      videoThumbnailItem.classList.remove('selected-thumbnail');
      videoThumbnailItem.classList.add('opacity-[0.5]');
    });

    currentThumbnailItem.classList.remove('opacity-[0.5]');
    currentThumbnailItem.classList.add('selected-thumbnail');

    const videoNumber = currentThumbnailItem.dataset.videoNumber;
    const number = currentThumbnailItem.dataset.number;
  
    const videoElement = document.getElementById(videoNumber);
  
    videoItemContent.forEach(item => {
      item.classList.remove('flex');
      item.classList.add('hidden');
      shareVideoPopup.classList.add('hidden');      
    });
  
    videoElement.classList.remove('hidden');
    videoElement.classList.add('flex');
    
    const playIcon = videoElement.querySelector('.play-icon');
    playIcon.classList.add('hidden');

    if (video) {
      video.removeEventListener('timeupdate', progressBarVideoUpdate);
      video.pause();        
      video.muted = true;
      video = null;
    }

    video = videoElement.querySelector('video');
    video.currentTime = 0;
    video.play();
    video.muted = muted;

    video.addEventListener('timeupdate', progressBarVideoUpdate);

    updateShareLinks(number);

    video.removeEventListener('ended', handleVideoEnded);
    videoIndex = number - 1;
    video.addEventListener('ended', handleVideoEnded);
  }

  function handlePlayPauseClick(event) {
    const playIcon = event.currentTarget.querySelector('.play-icon');
  
    if (video.paused) {
      video.play();
      playIcon.classList.add('hidden');
    } else {
      video.pause();
      playIcon.classList.remove('hidden');
    }
  }

  function handleShareLinkClick() {
    navigator.clipboard.writeText(shareVideoLinkButton.dataset.linkUrl);
  
    const textElement = shareVideoLinkButton.querySelector('.share-video-link-text');
    textElement.textContent = shareVideoLinkButton.dataset.copiedText;
  
    setTimeout(() => {
      textElement.textContent = shareVideoLinkButton.dataset.linkText;
    }, 3000);
  }

  function openSharePopup() {
    shareVideoPopup.classList.remove('hidden');
  }
  
  function closeSharePopup() {
    shareVideoPopup.classList.add('hidden');
  }

  function updateShareLinks(number) {
    shareVideoLinks.forEach(link => {
      let href = link.href;
      href = href.slice(0, -1) + number;
      link.href = href;
    });

    let link_data = shareVideoLinkButton.dataset.linkUrl;
    link_data = link_data.slice(0, -1) + number;
    shareVideoLinkButton.dataset.linkUrl = link_data;
  }

  function handleVideoEnded() {
    const nextIndex = videoIndex + 1;
    if (nextIndex < videoItems.length) {
      videoThumbnailItems[nextIndex].click();
    } else {
      videoThumbnailItems[0].click();
    }
  }

  videoItems.forEach((videoItem, index) => {
    videoItem.addEventListener('click', (event) => {
      const videoNumber = event.currentTarget.dataset.videoNumber;
      const number = event.currentTarget.dataset.number;

      videoThumbnailItems.forEach(videoThumbnailItem => {
        const currentThumbnailNumber = videoThumbnailItem.dataset.number;

        if (currentThumbnailNumber === number) {
          videoThumbnailItem.classList.add('selected-thumbnail');
          videoThumbnailItem.classList.remove('opacity-[0.5]');
        } else {
          videoThumbnailItem.classList.remove('selected-thumbnail');
          videoThumbnailItem.classList.add('opacity-[0.5]');
        }

        videoThumbnailItem.addEventListener('click', handleVideoThumbnailClick);
      });

      const videoElement = document.getElementById(videoNumber);
      
      document.body.style.overflow = 'hidden';
      videoPlayer.classList.remove('hidden');

      videoElement.classList.remove('hidden');
      videoElement.classList.add('flex');
      const playIcon = videoElement.querySelector('.play-icon');
      playIcon.classList.add('hidden');

      video = videoElement.querySelector('video');
      video.play();
      video.muted = muted;

      updateShareLinks(number);

      video.addEventListener('timeupdate', progressBarVideoUpdate);

      videoIndex = index;
      video.addEventListener('ended', handleVideoEnded);
    });
  });

  if (param_video && param_video !== '0') {
    videoItems[param_video - 1].click();

    const videoElement = document.getElementById(`video-${param_video}`);
    const playIcon = videoElement.querySelector('.play-icon');
    playIcon.classList.remove('hidden');

    video = videoElement.querySelector('video');    
    video.muted = true;
    video.play();
    video.pause();
    video.muted = false;
  }

  muteVideoButton.addEventListener('click', () => {
    if (!video) return;
    muteVideoUpdate();
  });

  shareVideoLinkButton.addEventListener('click', () => {
    if (!video) return;
    handleShareLinkClick();
  });

  shareVideoPopupOpenButton.addEventListener('click', () => {
    if (!video) return;
    openSharePopup();
  });

  shareVideoPopupCloseButton.addEventListener('click', () => {
    if (!video) return;
    closeSharePopup();
  });

  progressBar.addEventListener('input', () => {
    if (!video) return;
    progressBarInputUpdate();
  });

  playPauseButtons.forEach(playPauseButton => {
    playPauseButton.addEventListener('click', (event) => {
      if (!video) return;
      handlePlayPauseClick(event);
    });
  });

  closeVideoButton.addEventListener('click', () => {
    videoPlayer.classList.add('hidden');
    document.body.style.overflow = 'auto';

    videoThumbnailItems.forEach(videoThumbnailItem => {
      videoThumbnailItem.removeEventListener('click', handleVideoThumbnailClick);
    });

    if (video) {
      video.removeEventListener('timeupdate', progressBarVideoUpdate);
      video.pause();        
      video.muted = true;
      video = null;
    }

    videoItemContent.forEach(item => {
      item.classList.remove('flex');
      item.classList.add('hidden');
      shareVideoPopup.classList.add('hidden');      
    });
  }); 
});
